import { useState, useCallback } from 'react';
import useHttp from '../http/useHttp';
export default function useSearchAssociations() {
  const { postDataResponse, postData, getDataResponse, getData } = useHttp();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const search = useCallback(async (value: string, entityType?: string) => {
    setIsLoading(true);
    {
      entityType == 'facility' ? await postData('Entity/searchfacility', {
        searchText: value,
        pageNo: 0,
        pageSize: 10
      }) :
      await postData('entity/search', {
        searchText: value,
        type: entityType
      })
    }

    setIsLoading(false);
  }, []);

  const getFacility = useCallback(async (id: any) => {
    setIsLoading(true);
    try {
      await getData(`Entity/facility?id=${id}`);
    } catch (error) {
      console.error('Error fetching facility data:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data: postDataResponse?.data ?? { count: 0, custodians: [] },
    search,
    facilityData: getDataResponse?.data,
    getFacility,
    isLoading,
  };
}
